module.exports = __webpack_public_path__ + "scroll-bar-bg.8e60cdc8.png";